/*
* Copyright Gregory Coburn 2020-2026, All Rights Reserved, See license for further details
*/
import { Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogModule } from '@angular/material/dialog';
import { of } from 'rxjs';
import { MyInjector } from '@src/app/app.module';
import { uuid } from '@src/app/model/abstract-object';
import { FORUM_PRIVS, Forum } from '@src/app/model/forum';
import { ActionColor, IFormAction } from '@src/app/shared/form/form.component';
import { ForumService } from '@src/app/modules/social/forum/forum.service';
import { Person } from '@src/app/model/person';
import { FormsModule } from '@angular/forms';
import { Area } from '@src/app/model/area';
import { Core } from '@src/app/model/core';
import { AreaService } from '@src/app/modules/unit/area.service';
import { UnitType } from '@src/app/model/unit-type';
import { UnitCategory } from '@src/app/model/unit-category';
import { UnitTypeService } from '@src/app/modules/unit/unit-type-page/unit-type.service';

export class ForumPeopleAction implements IFormAction {
    name = $localize`Show People`;
    color: ActionColor = 'primary';
    show = false;
    icon = 'groups';
    approvalNeeded = false;
    disabled = false;
    approvalText = "";
    tipText = 'Shows the users associated to this channel';
    teamId: uuid;
    forum: Forum;

    action(forum: Forum) {
        console.log(forum);
        MyInjector.instance.get(MatDialog).open(ForumPeopleComponent, {data: this.forum});
        return of(this.forum);
    }
    //  setup(serviceRequest: ServiceRequest) {
    setup(forum: Forum) {
        this.forum = forum;
        this.show = true;
    }
}

@Component({
    selector: 'app-forum-people',
    imports: [MatDialogModule, FormsModule],
    templateUrl: './forum-people.component.html',
    styleUrl: './forum-people.component.scss'
})
export class ForumPeopleComponent {
    forum = inject<Forum>(MAT_DIALOG_DATA);
    private forumService = inject(ForumService);


    people: Person[] = [];
    areaSvc = inject(AreaService);
    typeSvc = inject(UnitTypeService);

    // Signals (via data-form-ready in the template) that the profile list has loaded, so the
    // Playwright framework can wait for it like any other form. This dialog has no embedded
    // <app-form> to stamp the attribute, so we drive it from here.
    ready = false;

    areas: Area[] = [];
    types: UnitType[] = [];

    forumPrivs = FORUM_PRIVS;
    selectedPriv = this.forumPrivs.find(o=>o.id==='canEdit');
    selectedArea : Area;
    selectedCore : Core;
    selectedType : UnitType;
    selectedCategory: UnitCategory;

    constructor() {
        this.changePriv();
        this.areaSvc.get<Area>(true).subscribe ( areas => this.areas = areas);
        this.typeSvc.get<UnitType>(true).subscribe ( types => this.types = types);
    }

    changeArea() {
        this.selectedCore = null;
        this.changePriv()
    }

    changeType() {
        this.selectedCategory = null;
        this.changePriv()
    }    

    changeCore() {
        this.changePriv()
    }

    changePriv() {
        this.forumService.getPeople(this.forum, this.selectedPriv, this.selectedArea?.id, this.selectedCore?.id, this.selectedType?.id, this.selectedCategory?.id).subscribe( (peeps: Person[]) => {
            this.people.length = 0;
            peeps.forEach ( p => this.people.push(p));
            this.ready = true;
        });
    }
}
